var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 4,
    viewBox: "0 0 24 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3582_110584",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V4H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3582_110584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00170898 2.9198C2.00884 2.91827 2.01892 0.99009 3.98243 0.988601C5.98957 0.987083 5.99135 3.02265 7.95486 3.02116C9.96196 3.01963 9.96019 0.984066 11.9236 0.982577C13.9308 0.981059 13.9326 3.01663 15.8961 3.01514C17.9033 3.01362 17.9015 0.978052 19.865 0.976563C21.8721 0.975036 22.0364 2.92128 24 2.91979",
    stroke: "#2B6ED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.38e54aac64be5a86a6b72d0edf7bf3ba.svg";
export { ForwardRef as ReactComponent };